<template>
  <div id="about-content" class="opacity-null">
    
    <section class="about">
      <div id="about-text">
        <h1>Founded in 2016, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.</h1>
        <span class="uppercase">As a collective, we provide visual packages including:</span>
        <div class="services-table uppercase">
          <span>BRANDING</span> |
          <span>WEBSITES</span> |
          <span>MAGAZINES</span> |
          <span>ILLUSTRATIONS</span><br>
          <span>PHOTOGRAPHY</span> |
          <span>VIDEOGRAPHY</span> |
          <span>COPYWRITING</span>
        </div>
      </div>

      <div class="contact-info uppercase">
        <p>
          <span class="get-in-touch">Get in touch:<br></span>
          <a class="mail-link button-style left hover" href="mailto:mail@onimo-studios.com">mail@onimo-studios.com</a>
        </p>

        <p>
          Our office:<br>
          <a class="underline" target="_blank" href="https://www.google.at/maps/place/Sigmundstadl+1,+8020+Graz/">Sigmundstadl 1</a><br><span class="no-break">8020 Graz</span>
          <!-- MARTIN LUTHER HAUS, <br class="mobile snd">2ND FLOOR -->
        </p>
      </div>
    </section>


    <section class="team">
      <h1>Our team</h1>
      <div class="member">
        <span>ART DIRECTION</span>
        Yue-Shin Lin<br>Margit Steidl
      </div>

      <div class="member">
        <span>WEB + CODING</span>
        Dennis Helbig
      </div>

      <div class="member">
        <span>GRAPHIC DEPARTMENT</span>
        Katharina Schwarz
      </div>
      
      <div class="member">
        <span>COMMUNICATIONS</span>
        Lilly Jagl
      </div>

      <!-- <div class="member">
        Valentina Gatterer
        <span>ANIMATION + ILLUSTRATION</span>
      </div> -->
    </section>

</div>
</template>



<script>
import {gsap, Power3} from 'gsap';
// import {setFooterSlideUp,footerSlideUp} from '../functions/transitions.js';
export default {
  name: 'About',
  props:{
    postArray: Array,
  },

  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'About',
    meta: [
      { vmid: 'og:title', name: 'og:title', content: 'About ONIMO studios' },
      { vmid: 'description', name: 'description', content: 'Founded by Yue-Shin Lin and Dennis Helbig, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.' },
      { vmid: 'og:description', name: 'og:description', content: 'Founded by Yue-Shin Lin and Dennis Helbig, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.' },
   
      { vmid: 'og:image', name: 'og:image', content: 'https://onimo-studios.com/fb-banner.png' },
      { vmid: 'og:url', name: 'og:url', content: 'https://onimo-studios.com/about/' },
    ]
  },

  methods:{
    createSchema(){
      const script = document.createElement('script');
      script.id = 'schema';
      script.type = 'application/ld+json';
      script.innerHTML = `
        {
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "ONIMO studios",
          "description": "Founded in 2016, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.",
          "specialty": "branding, websites, web development, magazines, illustrations, videos, photos, copywriting",
          "relatedLink": "https://thecakeescape.com/",
          "about": "Founded in 2016, ONIMO studios pursues the creation of progressive design and coding for individual and forward thinking people.",
          "publisher": {
            "@type": "LocalBusiness",
            "name": "ONIMO studios",
            "logo": "https://onimo-studios.com/about",
            "email": "mail@onimo-studios.com",
            "sameAs": [
              "https://www.instagram.com/onimostudios/",
              "https://www.facebook.com/onimostudios/"
            ],
            "url": "https://onimo-studios.com/about",
            "image": "https://onimo-studios.com/about",
            "description": "Design and Coding for Individual and Forward Thinking People",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Sigmundstadl 1",
              "addressLocality": "Graz",
              "addressRegion": "Styria",
              "postalCode": "8020",
              "addressCountry": "AT"
            },
            "founders": [
              {
                "@type": "Person",
                "name": "Yue-Shin Lin",
                "sameAs": "https://linyueshin.com/"
              },
              {
                "@type": "Person",
                "name": "Dennis Helbig",
                "sameAs": "https://dennishelbig.dev/"
              }
            ],
            "members": [
              {
                "@type": "Person",
                "name": "Yue-Shin Lin",
                "sameAs": "https://linyueshin.com/"
              },
              {
                "@type": "Person",
                "name": "Dennis Helbig",
                "sameAs": "https://dennishelbig.dev/"
              },
              {
                "@type": "Person",
                "name": "Margit Steidl",
                "sameAs": "https://www.studiolo-m.com/"
              },
              {
                "@type": "Person",
                "name": "Katharina Schwarz",
                "sameAs": "https://www.behance.net/katharinaschwarz/"
              },
              {
                "@type": "Person",
                "name": "Lilly Jagl",
                "sameAs": "https://www.instagram.com/lillyjagl/"
              }
            ]
          }
        }`;
      document.head.appendChild(script);
    },

    removeOpacity(){
      if( this.$root.$el.classList.contains('ready') ){

        gsap.to( this.$el, {
          opacity: 1,
          y: 0,
          duration: 0.5,
          ease: Power3.easeOut
        });
      }else{
        setTimeout(() => {
          this.removeOpacity();
        }, 100);
      }
    }
  },
  created(){
    this.createSchema()
  },
  mounted(){
    var $app = this.$root.$el;
    var $container = this.$el;

    if( !this.$root.$el.classList.contains('ready') ){
      gsap.set(this.$el,{
        opacity: 0,
        y: 100
      });

      this.removeOpacity();
    }
  },

  beforeDestroy(){
    const script = document.getElementById('schema');
    document.head.removeChild(script);
  },

  updated(){
    if( this.$root.$el.classList.contains('ready') ){
      this.removeOpacity();
    }
  }
}
</script>



<style lang="scss" scoped>
  svg path{
    fill: black;
  }
  @import '../scss/misc.scss';

  #about-content{
    @include content-bottom();
    position: relative;

    @media( $max768 ){
      margin-top: 3em;
    }

    display: flex;
    justify-content: space-between;

    @media( max-width: 1080px ){
      display: block;
    }
  }

  h1{
    margin-top: 0;
    margin-bottom: 2rem;
  }

  .about{
    width: 600px;
    margin-right: 10em;

    @media( max-width: 1080px ){
      max-width: 600px;
      width: 100%;
      margin-right: 0;
    }
  }

  .team{
    flex-grow: 1;
    max-width: 45%;
    margin-bottom: 200px;
  
    .member{
      letter-spacing: 0.02em;
      margin-bottom: 2em;
      &:last-child{
        margin-bottom: 0em;
      }
      span{
        display: block;
        // text-decoration: underline;
        letter-spacing: 0.12em;
      }
    }
  }

  #about-text{
    margin-bottom: 6em;

    @media( $max640 ){
      margin-bottom: 2em;
    }
  }

  .contact-info{
    margin-bottom: 100px;
  }


  .mail-link{
    margin-left: -15px;
    margin-bottom: 2rem;
  }

</style>